import { useTranslation } from "react-i18next";
import ProfileCard from "../common/profileCard";
import StudentSidebar from "../common/studentSidebar";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ProgressCard from "../common/progressCard";
import { useAuth } from "../../../core/hooks/useAuth";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import Skeleton from "react-loading-skeleton";
import { Pagination } from "../../../core/common/ults/pagination";
import { useState } from "react";

const StudentProgress = () => {
  const { t } = useTranslation();
  const { moodleUser } = useAuth();
  const { enrolledCourses, isEnrolledCoursesLoading } = useHandleCourses(moodleUser?.id);

  const itemsPerPage = 4;
  const [currentPage, setCurrentPage] = useState(1);

  // Filter dữ liệu khoá học (nếu cần lọc theo điều kiện nào đó, ví dụ đã ghi danh)
  const courseArray = Array.isArray(enrolledCourses) ? enrolledCourses : [];

  // Tính toán phần tử theo trang hiện tại
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentCourse = courseArray.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="content">
      <div className="container">
        <ProfileCard />
        <div className="row">
          <StudentSidebar />
          <div className="col-lg-9">
            <Breadcrumb title={t("progress.title")} />
            <div className="page-title d-flex align-items-center justify-content-between">
              <h5 className="fw-bold">{t("progress.title")}</h5>
            </div>

            {isEnrolledCoursesLoading ? (
              <Skeleton height={130} count={2} className="mb-3" />
            ) : (
              <>
                {currentCourse.length > 0 ? (
                  currentCourse.map((item: any) => (
                    <ProgressCard key={item.id} courseData={item} />
                  ))
                ) : (
                  <p className="text-muted">{t("progress.noCourses")}</p>
                )}
              </>
            )}

            {/* Pagination chỉ hiển thị nếu có nhiều hơn 1 trang */}
            {courseArray.length > itemsPerPage && (
              <Pagination
                totalItems={courseArray.length}
                itemsPerPage={itemsPerPage}
                onPageChange={(page: number) => setCurrentPage(page)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentProgress;
